<template>
    <!-- 滑动返回上一页 -->
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles invoiceCheck">
            <!-- 顶部导航，标题，返回按钮，返回按钮名称 -->
            <van-nav-bar
                title="发货单核对列表"
                left-text=""
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <div class="dateSection">
                <p @click="openDatetimePicker('begin')">
                    <span class="iconfont iconrili"></span>
                    <span>{{ beginTime }}</span>
                </p>
                <p class="line"></p>
                <p @click="openDatetimePicker('end')">
                    <span class="iconfont iconrili"></span>
                    <span>{{ endTime }}</span>
                </p>
            </div>
            <!-- 日期选择 -->
            <van-popup
                v-model="dateShow"
                position="bottom"
                :lazy-render="false"
                :style="{ height: '30%' }"
            >
                <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    title="选择年月日"
                    :max-date="maxDate"
                    @confirm="datetimeConfirm"
                    @cancel="datetimeCancel"
                >
                </van-datetime-picker>
            </van-popup>
            <!-- 列表加载更多 -->
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                <van-list
                    v-model="isUpLoading"
                    :finished="finished"
                    finished-text="没有更多了!"
                    @load="onLoad"
                >
                    <ul class="list">
                        <template v-for="(item, index) in orderData">
                            <li :key="index">
                                <div class="engineeringInfo">
                                    <span v-if="item.all_count == item.checked_count" class="state iconfont iconjiaobiao">
                                        <i>已完成</i>
                                    </span>
                                    <span v-if="item.all_count != item.checked_count" class="state iconfont iconjiaobiao unfinished">
                                        <i>未完成</i>
                                    </span>
                                    <h4 class="engineeringInfo_header">
                                        <span class="headerName">场站：{{ item.station_name }}</span>
                                    </h4>
                                    <div class="engineeringInfo_content">
                                        <p>
                                            <span>发货单总数:{{ item.all_count }}</span>
                                            <span>已核对发货单:{{ item.checked_count }}</span>
                                        </p>
                                        <p class="bill">
                                            <span @click="openMissingInvoice(item)">缺失发货单：{{ item.lost_count }}</span>
                                            <span @click="openChangeInvoiceNumber(item)">调整签收方量单数：{{ item.adjusted_count }}</span>
                                        </p>
                                        <p class="checkFinish">
                                            <span>核对时间:{{ item.checked_date }}</span>
                                            <span v-show="false" class="btn fr">核对完成</span>
                                        </p>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </ul>
                </van-list>
            </van-pull-refresh>
            <div class="scanCodeBtn" @click="openScanCode">
                <div>
                    <span class="iconfont iconsaoma1"></span>
                </div>
                <p>扫码</p>
            </div>
        </div>
    </v-touch>
</template>

<script>
import util from '@/utils/util';
import { eventBus } from '@/common/eventBus.ts';
export default {
    // 核对列表
    name: 'invoice-check',
    components: {},
    props: {},
    data() {
        return {
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 上拉索引
            count: 1,
            // 列表总条数
            total: 0,
            // 记录上拉还是下拉
            slidingDirection: '',
            // 日期选择器最大日期
            maxDate: new Date(),
            // 日期选择器当前日期
            currentDate: null,
            // 日期选择器是否弹出
            dateShow: false,
            // 开始时间
            beginTime: '',
            // 结束时间
            endTime: '',
            // 记录开始时间还是结束时间
            dateState: '',
            // 列表数据
            orderData: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        // 转发原生回调函数
        window.callback_GetTeamsListInfo = this.callback_GetTeamsListInfo;
        const prevDay = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
        this.currentDate = prevDay;
        this.beginTime = util.timeFormat(this.currentDate, 'yyyy-MM-dd');
        this.endTime = util.timeFormat(new Date(), 'yyyy-MM-dd');

        window.jyCallback_DriveScanFinished = this.jyCallback_DriveScanFinished;

        eventBus.$on('OpenScanCode', () => {
            this.openScanCode();
        });
    },
    mounted() {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'invoice-check');
        }
        next();
    },
    destroyed() {},
    methods: {
        // 打开扫码
        openScanCode() {
            this.$callMobile('JYTeamsNative', 'jyDriveScanClick', '');
        },
        // 扫码回调的函数
        jyCallback_DriveScanFinished(data) {
            if (data) {
                const delivery_receipt_number = data.replace(/\+/g, '');
                // const delivery_receipt_number = data.split('+')[1];
                this.$axios.get('/interfaceApi/sale/accounts/get_pcd/' + delivery_receipt_number).then(data => {
                    if (data) {
                        this.$router.push({ path: '/scanCodeCheck', query: {
                            deliveryData: data,
                        } });
                    } else {
                        this.$dialog({ message: '未找到排车单：' + delivery_receipt_number });
                    }
                }).catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
            } else {
                this.$dialog({ message: '二维码错误' });
            }

        },
        // 打开年月日选择器
        openDatetimePicker(type) {
            this.dateState = type;
            const beginTime = this.switchDate(this.beginTime);
            const endTime = this.switchDate(this.endTime);
            if (type === 'begin') {
                this.currentDate = new Date(beginTime);
            } else if (type === 'end') {
                this.currentDate = new Date(endTime);
            }
            setTimeout(() => {
                this.dateShow = true;
            }, 10);
        },
        // 日期选择日确认
        datetimeConfirm(date) {
            const selectTime = new Date(date);
            if (this.dateState === 'begin') {
                const endTime = this.switchDate(this.endTime);
                if (selectTime > endTime) {
                    this.$dialog({ message: '开始时间不能大于结束时间！' });
                    return false;
                }
                this.beginTime = util.timeFormat(new Date(date), 'yyyy-MM-dd');
            } else if (this.dateState === 'end') {
                const beginTime = this.switchDate(this.beginTime);
                if (selectTime < beginTime) {
                    this.$dialog({ message: '结束时间不能小于开始时间！' });
                    return false;
                }
                this.endTime = util.timeFormat(new Date(date), 'yyyy-MM-dd');
            }
            this.dateShow = false;
            this.getOrderData();
            return true;
        },
        // 日期选择日取消
        datetimeCancel() {
            this.dateShow = false;
        },
        // 打开缺失发货单
        openMissingInvoice(item) {
            this.$router.isBack = 2;
            this.$router.push({ path: '/missingInvoice', query: { station_id: item.station_id, checked_date: item.checked_date } });
        },
        // 打开调整签收方量单数
        openChangeInvoiceNumber(item) {
            this.$router.isBack = 2;
            this.$router.push({ path: '/changeInvoiceNumber', query: { station_id: item.station_id, checked_date: item.checked_date } });
        },
        // 返回上级菜单
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        // 下拉刷新
        onRefresh() {
            this.getOrderData();
        },
        // 上拉加载更多
        onLoad() {
            this.getOrderData();
        },
        // 拉取发货单数据
        getOrderData() {
            this.$axios
                .get('/interfaceApi/sale/accounts/get_scan_day', { params: { beginTime: this.beginTime, endTime: this.endTime } } )
                .then(res => {
                    this.orderData = res;
                    this.isLoading = false;
                    this.isUpLoading = true;
                    this.finished = true;
                })
                .catch(error => {
                    this.isLoading = false;
                    this.finished = true;
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 切换为日期格式date
        switchDate(date, type) {
            type = type || '-';
            const dateArr = date.split(type);
            dateArr[1] = dateArr[1] - 1;
            const dateObj = new Date(...dateArr);
            return dateObj;
        },
    },
    beforeDestroy() {
        eventBus.$off('OpenScanCode');
    },
};
</script>
<style lang="stylus" scoped>

.invoiceCheck
    height 100%
    .dateSection
        display flex
        height 40rpx
        justify-content center
        align-items center
        p span
            color #333
        .iconrili
            font-size 18rpx
            cursor pointer
            color: #5588F1
            margin-right 5rpx
        .line
            width 16rpx
            height 1px
            margin 0 10rpx
            background #d7d7d7
    .van-pull-refresh
        height calc(100% - 84rpx)
        background #f0f0f0
        overflow-y auto
        .list
            li
                position relative
                p
                    display flex
                    align-items center
                    margin-bottom 15rpx
                    vertical-align middles
                    span
                        display inline-block
                        height 16rpx
                        line-height 16rpx
                    span
                        font-size 14rpx
                        color #666
                .checkFinish
                    position relative
                    .btn
                        position absolute
                        top 0
                        right 0
                        display flex
                        justify-content center
                        align-items center
                        width: 70rpx
                        height: 25rpx
                        margin-right 13rpx
                        font-size 12rpx
                        color #fff
                        background: #5588F1
                        border-radius: 4rpx
                    .fr
                        float right
                .bill
                    padding-left 28rpx
                    box-sizing border-box
                    span
                        width 50%
                        color #419DFF
                        text-decoration underline
                .state
                    position absolute
                    top 0
                    right 0
                    font-weight 400
                    width 40rpx
                    height 40rpx
                    &:before
                        font-size 40rpx
                        line-height 40rpx
                        color #FF6600
                        position absolute
                        top 0px
                        right 0
                    i
                        position absolute
                        width 40rpx
                        text-align center
                        font-size 10rpx
                        color #FFFFFF
                        transform rotate(45deg)
                        top 7rpx
                        left 7rpx
                .unfinished
                    &:before
                        color #979EA7
    .scanCodeBtn
        padding 5rpx 10rpx 10rpx 10rpx
        background #0189FC
        box-shadow 2rpx 2rpx 4rpx 0 rgba(0, 0, 0, 0.35)
        border-radius 4rpx
        position absolute
        bottom 15rpx
        right 20rpx
        z-index 10
        text-align center
        color #fff
        .iconfont
            font-size 20rpx
        p
            font-size 12rpx
</style>
